// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"e99fa3d1","238":"43d8b2d6","575":"4a74e6d5"}[chunkId] + ".chunk.js";
};